<template>
  <footer>
    <div class="map">
      <div data-ornament="circle"/>
    </div>
    <div class="footer__content" data-module="footerContent">
      <div class="logo">
        <span data-icon="logo" />
      </div>
      <div class="outlinks">
        <p>Find us on the internet</p>
        <ul>
          <li v-for="link in companyInfo.socialMedia" :key="link.platform">
            <a :href="link.url" data-type="base-bigger">{{link.platform}}</a>
          </li>
        </ul>
        <small class="copyright">
          © 2021 Particle Design
        </small>
      </div>
      <div class="hire-us">
        <p>Plan a project</p>
        <router-link v-bind:to="{ name: 'L2', params: { slug: 'contact', hash: 'contact-us-form' }, hash: '#contact-us-form' }" data-type="title" @click.native="scrollTo('#contact-us-form')">
          Hire Us
        </router-link>
        <div class="spacers">
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
        </div>
        <address data-type="default">
          {{companyInfo.address.address1}}
          <br />
          {{companyInfo.address.address2}}
        </address>
      </div>
    </div>
  </footer>
</template>

<script>
import companyInfo from '@/data/snippets/companyInfo';

export default {

  name: 'layoutFooter',

  data: function() {
    return {
      companyInfo,
    };
  },

  methods: {

    scrollTo: function(hash) {
      // vue-router won't scroll to anchors if you already browsed to it
      // because the url is identical and it boots out
      // use native click as a fallback
      location.href = hash;
    },

  },

};
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
@import '../../styles/_mixins.scss';
@import '../../styles/_icons.scss';

footer {
  margin: $component-spacer auto 0 auto;
  max-width: $layout--max-width;
  background: black;
  padding: rem(100px) 0 rem(50px) 0;

  color: #8B969A;

  .footer__content {
    @include grid($subgrid: true);
    width: 100%;

  }

  .logo {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row: 1 / span 1;
    margin-left: rem(-35px);



    [data-icon="logo"] {
      margin: 0.5rem auto 0 auto; // optically align w/rest of footer items
      display: inline-block;
      width: rem(120px);

      &::before {
        content: '';
        width: 100%;
        display: block;
        padding-bottom: 100%;
       // @include drawIcon($key: logo, $base-color: orange);
        background: url('../../assets/logo_uncontained.svg') no-repeat center top;
        background-size: contain;


      }
    }
  }

  .outlinks {
    grid-column-start: 3;
    grid-column-end: 6;
    grid-row: 1 / span 1;

    ul {
      margin: 0;
      list-style: none;
      padding: 0;
    }

    a {
      color: #f0f0f0;
    }
  }

  .hire-us {
    grid-column-start: 6;
    grid-column-end: 10;
    grid-row: 1 / span 1;

    a {
      color: #f0f0f0;

      &:hover,
      &:focus,
      &:active {
        color: $color--primary-highlight;
        text-decoration: none;
      }
    }
  }

  address {
    font-style: normal;
  }

  .copyright {
    margin-top: rem(100px);
    display: block;
  }

  .map {
    position: absolute;
    bottom: 0;
    left: 50%;
    right: 0;
    // height: rem(600px);
    height: 100%;
    // width: rem(761px);
    background-image: url('~@/assets/footer_map.jpg'), linear-gradient(rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%);
    background-position: center center;
    background-size: cover;

    [data-ornament] {
      position: absolute;
      top: 0;
      left: 40%;
      transform: translateY(-50%);
      width: rem(100px);
    }
  }

  @include mq(1024px, down) {
    margin: 0 auto;

    .footer__content {
      @include grid($subgrid: true, $rows: 2);
    }

    .logo {
      grid-column: 1 / span 6;
    }

    .outlinks {
      grid-column: 6 / span 6;
    }

    .copyright {
      margin-top: 1rem;
      margin-bottom: 2.5rem;
    }

    .hire-us {
      grid-column: 6 / span 6;
      grid-row: 2 / span 1;
    }

    .map {
      display: none;
    }
  }

  @include mq($bp--mobile, down) {
    .footer__content {
      @include grid($subgrid: true, $rows: 3);
    }

    .logo {
      grid-row: 1 / span 1;
      grid-column: 1 / -1;

      text-align: right;
    }

    .outlinks {
      grid-row: 2 / span 1;
      grid-column: 1 / -1;

      text-align: right;
    }

    .hire-us {
      grid-row: 3 / span 1;
      grid-column: 1 / -1;

      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/includes/footer.vue